// super manage leader dep market

const filter_list = {
    '/login': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/home': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/unreach': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/treat_token': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    
    '/pwd': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/hospitals': {super: 0, manage: 0, leader: 0, dep: -1, market: -1},
    '/app_types': {super: 0, manage: 0, leader: 0, dep: -1, market: -1},
    '/agents': {super: 0, manage: 0, leader: 0, dep: -1, market: -1},

    '/edges': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},//market只能看到自己负责的edge TODO
    '/all_edges': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},//market只能看到自己负责的edge TODO
    '/edge_exp': {super: 0, manage: 0, leader: 0, dep: 0, market: 0}, //market只能看到自己负责的edge TODO
    '/pcs': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    // '/usage': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/serials': {super: 0, manage: 0, leader: 0, dep: 0, market: -1},
    '/serial_ntlong': {super: 0, manage: 0, leader: 0, dep: 0, market: -1},

    '/licenses': {super: 0, manage: 0, leader: 0, dep: 0, market: -1},
    '/license_apply': {super: 0, manage: 0, leader: 0, dep: 0, market: -1},
    '/lic_upload': {super: 0, manage: 0, leader: 0, dep: -1, market: -1},
    '/lic_notice': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/applies': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/applies_done': {super: 0, manage: 0, leader: 0, dep: 0, market: -1},

    '/task_run': {super: 0, manage: 0, leader: -1, dep: -1, market: -1},
    '/tool_kit': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/logs': {super: 0, manage: 0, leader: -1, dep: -1, market: -1},

    '/batch': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/batch_list': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/iq_list': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/jump': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/exp_report_all': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/exp_report_detail': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_apply': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_done': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_person': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_ready': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_reject': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/expense_wait': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},

    '/demo_upload_login': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/demo_upload_history': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/demo_upload': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/check_config': {super: 0, manage: 0, leader: 0, dep: 0, market: 0},
    '/lic_generate': {super: 0, manage: -1, leader: 0, dep: -1, market: -1},
    '/ai_files': {super: 0, manage: -1, leader: -1, dep: -1, market: -1}
}

export default {
    redirectIfNotAuthenticated(to, from, next) {
        if (to.path === '/login' || to.path === '/unreach' || to.path === '/treat_token' || to.path === '/pwd') {
            next()
        } else {
            //核验权限
            const token = localStorage.getItem("token")
            if (token !== undefined && token !== null) {
                const token_obj = JSON.parse(token)
                if (to.path === '/home' || to.path === '/') {
                    next()
                } else if (token_obj.isFirstLogin === 0) {
                    next({ path: '/pwd' })
                } else {
                    if (filter_list[to.path][token_obj.dep] === 0) {
                        next()
                    } else {
                        next({ path: '/unreach' })
                    }
                }
            } else {
                next({ path: '/login' })
            }
        }
    },
    filter_list
}